import React, { useState } from "react";
import { Select, Tooltip, Typography } from "antd";
import { withTranslation } from "react-i18next";
import { uniqBy } from "lodash";

import { defaultFilters, UNASSIGNED } from "../../constant/filters";
import { MultiSelect } from "../customComponent/CustomSelect";
import { WHITE } from "../../constant/colors";

const { Option } = Select;
const { Text } = Typography;

const AssigneeFilterComponent = ({
  t,
  value: currentAssignees,
  onChange,
  assignees,
  dataTMId,
  selectAll = false,
  clearAll = false,
  onClearAll,
  onSelectAll
}) => {
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [isSelectHover, setIsSelectHover] = useState(false);
  const unassingedObj = { value: UNASSIGNED, text: t("filter.assignee.no_assignee") };

  const validAssignees =
    currentAssignees &&
    currentAssignees.length &&
    currentAssignees
      .map((id) => {
        const assigneeObj = assignees.find((x) => x.value === id);
        return assigneeObj ? assigneeObj : unassingedObj; // if get by id returns undefined then means its Unassigned value
      })
      .sort((a, b) => a.text.localeCompare(b.text));

  const assigneesTextToDisplay =
    (validAssignees && validAssignees.length > 0 && validAssignees.map(({ text }) => text).join(" | ")) || "";

  const compareAssignees = (a, b) => {
    const aIsSelected = currentAssignees.indexOf(a.value) > -1;
    const bIsSelected = currentAssignees.indexOf(b.value) > -1;
    if ((aIsSelected && bIsSelected) || (!aIsSelected && !bIsSelected)) {
      return a.children.localeCompare(b.children);
    }
    if (aIsSelected && !bIsSelected) {
      return -1;
    }
    if (!aIsSelected && bIsSelected) {
      return 1;
    }
  };

  return (
    <Tooltip
      open={assigneesTextToDisplay.length && !isSelectOpen && isSelectHover}
      title={<Text>{assigneesTextToDisplay}</Text>}
      color={WHITE}
    >
      <MultiSelect
        changed={currentAssignees !== defaultFilters.assigneesFilter}
        value={!validAssignees ? [] : validAssignees.map(({ value }) => value)}
        onChange={onChange}
        placeholder={t("all")}
        filterSort={compareAssignees}
        dataTMId={dataTMId}
        onDropdownVisibleChange={(open) => setIsSelectOpen(open)}
        onMouseEnter={() => setIsSelectHover(true)}
        onMouseLeave={() => setIsSelectHover(false)}
        maxTagCount={1}
        maxTagTextLength={validAssignees.length > 10 ? 6 : 7}
        selectAll={selectAll}
        clearAll={clearAll}
        onClearAll={onClearAll}
        onSelectAll={onSelectAll}
      >
        <Option value={UNASSIGNED}>{t("filter.assignee.no_assignee")} </Option>
        {uniqBy(assignees, "value")
          .sort()
          .map((assignee, index) => (
            <Option key={index} value={assignee.value}>
              {assignee.text}
            </Option>
          ))}
      </MultiSelect>
    </Tooltip>
  );
};
const AssigneeFilter = withTranslation()(AssigneeFilterComponent);

export { AssigneeFilter };
